module.exports = __webpack_public_path__ + "static/media/fog.d914ccd6.svg";